import React, { useRef, useEffect, useState } from "react";
import KeyTable from "./KeyTable";
import DoorTable from "./DoorTable";
import PermissionTable from "./PermissionTable";
import { Door, Key, Permission } from "./types";
import StickyDoorPanel from "./StickyDoorPanel";
import StickyKeyPanel from "./StickyKeyPanel";

interface ConfiguratorContainerProps {
  doors: Door[];
  keys: Key[];
  permission: Permission[];
  handleAddDoor: () => void;
  handleAddKey: () => void;
  handleRemoveKeyx: (id: number) => void;
  handleKeyChange: (index: number, field: keyof Key, value: number | string) => void;
  handleRemoveDoorx: (id: number) => void;
  handleDoorChange: (index: number, field: keyof Door, value: string | number) => void;
  handleInputChange: (
    index: number,
    field: keyof Door,
    value: string | number,
    numb: number,
    step: number,
    name: string,
    innen: number,
    auben: number
  ) => void;
  getDefaultLockValues: (lockType: string) => { lockOutside: number; lockInside: number };
  handlePermissionChange: (idKey: number, idDoor: number, allow: boolean) => void;
  backendUrl: string;
}

const ConfiguratorContainer: React.FC<ConfiguratorContainerProps> = ({
  doors,
  keys,
  permission,
  handleAddDoor,
  handleAddKey,
  handleRemoveKeyx,
  handleKeyChange,
  handleRemoveDoorx,
  handleDoorChange,
  handleInputChange,
  getDefaultLockValues,
  handlePermissionChange,
  backendUrl,
  
  
}) => {
     const doorPanelRef = useRef<HTMLDivElement>(null);
  const doorTableRef = useRef<HTMLDivElement>(null);
const block1Ref = useRef<HTMLDivElement>(null);
  // Pole matrycy pod kursorem - podświetla odpowiadający wiersz drzwi i kolumnę klucza
  const [hoverCell, setHoverCell] = useState<{ door: number; key: number } | null>(null);
useEffect(() => {
  const panel = doorPanelRef.current;
  if (!panel) return;

  const parent = panel.parentElement;
  if (!parent) return;

  const handleScroll = () => {
    const parentRect = parent.getBoundingClientRect();
    const panelHeight = panel.offsetHeight;

    if (parentRect.top < 0 && parentRect.bottom > panelHeight) {
      // Panel przyklejony do góry ekranu
      panel.style.position = 'fixed';
      panel.style.top = '0px';
      panel.style.width = `${parentRect.width}px`;
    } else if (parentRect.bottom <= panelHeight) {
      // Panel osiągnął dół rodzica
      panel.style.position = 'absolute';
      panel.style.top = `${parent.offsetHeight - panelHeight}px`;
      panel.style.width = '100%';
    } else {
      // Panel w normalnym miejscu
      panel.style.position = 'relative';
      panel.style.top = '0';
      panel.style.width = '100%';
    }
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

  // KROK 2: Użyj useEffect do synchronizacji przewijania
  useEffect(() => {
    const tableContainer = doorTableRef.current;
    const panelContainer = doorPanelRef.current;
   
    if (!tableContainer || !panelContainer) return;

    const handleScroll = () => {
      // Ustaw pozycję przewijania panelu nagłówka na taką samą jak tabeli
      panelContainer.scrollLeft = tableContainer.scrollLeft;
    };

    // Dodaj event listener do kontenera tabeli
    tableContainer.addEventListener('scroll', handleScroll);

    // Funkcja czyszcząca - usuwa listener po odmontowaniu komponentu
    return () => {
      tableContainer.removeEventListener('scroll', handleScroll);
    };
  }, []); // Pusta tablica zależności sprawia, że efekt uruchomi się tylko ra
  
  // Obsługa kliknięcia na ikonki pomocy: na mobile pokaż tooltip po tapnięciu
  useEffect(() => {
    const icons = Array.from(document.querySelectorAll('.help-icon')) as HTMLElement[];
    const handler = (e: Event) => {
      const el = e.currentTarget as HTMLElement;
      if (!el) return;
      if (el.classList.contains('help-open')) {
        el.classList.remove('help-open');
      } else {
        // zamknij inne
        icons.forEach(i => i.classList.remove('help-open'));
        el.classList.add('help-open');
      }
    };
    icons.forEach(i => i.addEventListener('click', handler));
    return () => icons.forEach(i => i.removeEventListener('click', handler));
  }, []);

  // Zamykaj tooltipy, gdy użytkownik kliknie poza nimi
  useEffect(() => {
    const docHandler = (e: Event) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      // Jeśli kliknięto wewnątrz .help-icon, zostaw otwarte (kliknięcie obsługuje handler wyżej)
      if (target.closest && target.closest('.help-icon')) return;
      // Usuń klasę help-open ze wszystkich
      const opened = document.querySelectorAll('.help-icon.help-open');
      opened.forEach((el) => el.classList.remove('help-open'));
    };

    document.addEventListener('click', docHandler);
    return () => document.removeEventListener('click', docHandler);
  }, []);
  return (
  <div className="configurator-container">
    <div className="columns-wrapper">
      
      {/* --- BLOK 1: Lewy górny (Opis, KeyPanel, DoorPanel) --- */}
        <div className="block block-1">
  <div className="block-1-inner">
    {/* Lewa kolumna */}
    <div className="left-column">
      <div className="description-wrapper">
              <h1>Unser Konfigurator macht es Ihnen leicht, Ihren individuellen Schließplan zu erstellen:</h1>
              <div className="step">
                <div className="step-title">
                  1. Türbezeichnung:
                  <span className="help-icon" data-tooltip={"Tragen Sie alle Bezeichnungen für Türen, Tore, Haupteingang, Briefkasten usw. ein, um die Zuordnung der Schließzylinder beim Einbau zu erleichtern. Geben Sie zusätzlich die notwendige Stückzahl der Zylinder an."}>?</span>
                </div>
                <div className="step-description">
                  Tragen Sie alle Bezeichnungen für Türen, Tore, Haupteingang, Briefkasten usw. ein, um die Zuordnung der Schließzylinder beim Einbau zu erleichtern. Geben Sie zusätzlich die notwendige Stückzahl der Zylinder an.
                </div>
              </div>
              <div className="step">
                <div className="step-title">
                  2. Zylindertyp und Längen:
                  <span className="help-icon" data-tooltip={"Geben Sie die Maße für „außen“ und „innen“ ein. Unser System akzeptiert Werte von 27 bis 120 mm. Beachten Sie, dass sich die Länge in Schritten von 5 mm ändern kann."}>?</span>
                </div>
                <div className="step-description">
                  Geben Sie die Maße für „außen“ und „innen“ ein. Unser System akzeptiert Werte von 27 bis 120 mm. Beachten Sie, dass sich die Länge in Schritten von 5 mm ändern kann.
                </div>
              </div>
              <div className="step">
                <div className="step-title">
                  3. Schlüssel:
                  <span className="help-icon" data-tooltip={"Geben Sie die benötigte Schlüsselanzahl und den Namen der Schlüssel (General, Post, Reinigung, Gäste etc.) an."}>?</span>
                </div>
                <div className="step-description">
                  Geben Sie die benötigte Schlüsselanzahl und den Namen der Schlüssel (General, Post, Reinigung, Gäste etc.) an.
                </div>
              </div>
              <div className="step">
                <div className="step-title">
                  4. Schließplan-Matrix:
                  <span className="help-icon" data-tooltip={"Geben Sie für jeden Schlüssel durch ein Kreuz die Schließberechtigung für den jeweiligen Zylinder an."}>?</span>
                </div>
                <div className="step-description">
                  Geben Sie für jeden Schlüssel durch ein Kreuz die Schließberechtigung für den jeweiligen Zylinder an.
                </div>
              </div>
            </div>
        <div className="doorpanel-wrapper">
        <StickyDoorPanel parentRef={block1Ref} doors={doors} handleAddDoor={handleAddDoor} />
        </div>
    </div>

    {/* Prawa kolumna */}
    <div className="right-column">
  <StickyKeyPanel
                
                handleAddKey={handleAddKey}
                keys={keys}
              />
</div>
  </div>    
        </div>
      
      {/* --- BLOK 2: Tabele (KeyTable, DoorTable, PermissionTable) --- */}

      {/* Prawa kolumna, górny wiersz */}
      <div className="block">
        <KeyTable
          keys={keys}
          handleRemoveKeyx={handleRemoveKeyx}
          handleKeyChange={handleKeyChange}
          highlightedIndex={hoverCell?.key ?? null}
        />
      </div>

      {/* Lewa kolumna, dolny wiersz */}
      <div className="block">
        <DoorTable
          doors={doors}
          handleRemoveDoorx={handleRemoveDoorx}
          handleDoorChange={handleDoorChange}
          handleInputChange={handleInputChange}
          getDefaultLockValues={getDefaultLockValues}
          backendUrl={backendUrl}
          highlightedIndex={hoverCell?.door ?? null}
        />
      </div>

      {/* Prawa kolumna, dolny wiersz */}
      <div className="block">
        <PermissionTable
          doors={doors}
          keys={keys}
          permission={permission}
          handlePermissionChange={handlePermissionChange}
          backendUrl={backendUrl}
          hoverCell={hoverCell}
          onHoverCell={setHoverCell}
        />
      </div>

    </div>
  </div>
);

};

export default ConfiguratorContainer;